import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Max tags per module. Enforced here because FieldDescriptor has no `maxItems`
 * (request 0148 §1.1 / §8 — optional `_requests/data-access` later).
 */
export const MODULE_TAGS_MAX_ITEMS = 10;
/**
 * Normalize a single tag: trim, lowercase, spaces → hyphens, truncate to NAME limit.
 * Empty / non-string → `''` (caller discards).
 */
export function normalizeTag(raw) {
    if (typeof raw !== 'string')
        return '';
    const normalized = raw
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
    if (!normalized)
        return '';
    return normalized.slice(0, FIELD_LIMITS.NAME);
}
/**
 * Normalize a tags array: coerce, normalize each, dedupe, sort, enforce maxItems.
 * The **only** write-path normalizer for `Module.tags`.
 */
export function normalizeTags(raw) {
    if (raw == null)
        return [];
    let items;
    if (Array.isArray(raw)) {
        items = raw;
    }
    else if (typeof raw === 'string') {
        const trimmed = raw.trim();
        if (!trimmed)
            return [];
        items = trimmed.split(/[,;]+/);
    }
    else {
        return [];
    }
    const seen = new Set();
    const result = [];
    for (const item of items) {
        if (typeof item !== 'string')
            continue;
        const tag = normalizeTag(item);
        if (!tag || seen.has(tag))
            continue;
        seen.add(tag);
        result.push(tag);
        if (result.length >= MODULE_TAGS_MAX_ITEMS)
            break;
    }
    return result.sort((a, b) => a.localeCompare(b));
}
/** Distinct tags across a catalog — substitutes a Tag entity (spec §3.1). */
export function distinctTags(modules) {
    const seen = new Set();
    for (const mod of modules) {
        for (const tag of mod.tags ?? []) {
            const n = normalizeTag(tag);
            if (n)
                seen.add(n);
        }
    }
    return [...seen].sort((a, b) => a.localeCompare(b));
}
//# sourceMappingURL=moduleTags.js.map